export function downloadCSV(csv: string): void {
  const blob = new Blob([csv], { type: "text/csv" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = "CSV Export File";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
